import ApiService from "@/services/api";

const API = new ApiService();

export const state = {
  userItem: {},
  usersList: [],
  usersTotal: 0,
  userAccess: [],
  error: null,
  currentUser: []
};

export const mutations = {
  UPDATE_USER(state, list) {
    state.userItem = list;
  },
  UPDATE_USERS_LIST(state, list) {
    state.usersList = list;
  },
  UPDATE_USERS_TOTAL(state, total) {
    state.usersTotal = total;
  },
  UPDATE_USER_ACCESS(state, access) {
    localStorage.setItem('userAccess', JSON.stringify(access.message))
    state.userAccess = access;
  },
  UPDATE_CURRENT_USER(state, access) {
    localStorage.setItem('currentUser', JSON.stringify(access.message))
    state.userAccess = access;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  async getUsersList({ commit }) {
    return new Promise((resolve, reject) => {
      API.post("/user/list-users")
        .then((res) => {
          commit("UPDATE_USERS_LIST", res.message.rows.Items);
          commit("UPDATE_USERS_TOTAL", res.message.rows.TotalCount);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  async getUser({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post("/user/get-user", params)
        .then((res) => {
          commit("UPDATE_USER", res.message.rows.Item);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  async submitUser({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post(`/user/${params.action}`, params)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          commit("SET_ERROR", err);
          reject(err);
        });
    });
  },

  async deleteUserItem({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.post("/user/delete-user", params)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          commit("SET_ERROR", err);
          reject(err);
        });
    });
  },

  async getUserAccess({ commit }) {
    return new Promise((resolve, reject) => {
      API.post("/user/get-user-access")
        .then((res) => {
          commit("UPDATE_USER_ACCESS", res);
          resolve(res.message);
        })
        .catch((err) => {
          commit("SET_ERROR", err);
          reject(err);
        });
    });
  },

  async getUserBySub({ commit }) {
    return new Promise((resolve, reject) => {
      API.post("/user/get-current-user")
        .then((res) => {
          commit("UPDATE_CURRENT_USER", res);
          resolve(res);
        })
        .catch((err) => {
          commit("SET_ERROR", err);
          reject(err);
        });
    });
  },
};
